import { test as baseTest } from "@playwright/test";
import { coverageReport } from "./coverage-report";

// Extend the base test with custom hooks
const test = baseTest.extend({
    // Add beforeEach and afterEach hooks
    page: async ({ page }, use) => {
        // Start coverage before each test
        await page.coverage.startJSCoverage({ resetOnNavigation: false });
        await page.coverage.startCSSCoverage();

        // Use the page in the test
        await use(page);

        // Stop coverage after each test
        const [jsCoverage, cssCoverage] = await Promise.all([page.coverage.stopJSCoverage(), page.coverage.stopCSSCoverage()]);
        const coverageData = [...jsCoverage, ...cssCoverage];
        await coverageReport.add(coverageData);
    }
});

export { test };
